export default "__VITE_ASSET__ClK_cVZZ__"